<template>
    <div class="row ">
        <div class="col-6">
            <h2 class="form-inline mr-auto">{{ $trans.get('__JSON__.Requested vacations') }}
                <div class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge" style="font-size: 0.7rem; transform: translateY(-0.7rem);">
        {{ getCountVacationOpenRequests() }} </div> </h2>
        </div>
        <div class="col-6 form-check form-switch form-inline text-end">
            <div class="form-inline ml-auto mr-1 float-end">
                <span class="fs-4">{{ year }}</span>
            </div>
            <input v-model="year_switch" class="ml-3 form-inline form-check-input justify-content-end "
                type="checkbox" role="switch" style="transform: scale(1.8);" id="flexSwitchCheckDefault">
            <label class="ml-3 fs-4 form-inline form-check-label justify-content-end "
                for="flexSwitchCheckDefault">{{ getNextYear(year) }}</label>
        </div>
    </div>
    <table class="table table-striped hover-zoom">
        <thead>
            <tr>
            <th role="button" @click.prevent="sortColumn = 'employee'">
                {{ $trans.get('__JSON__.Employee') }}
                <i v-if="sortColumn == 'employee'" class="fa fa-sort-asc"></i>
            </th>
            <th role="button" @click.prevent="sortColumn = 'team'">
                {{ $trans.get('__JSON__.Team') }}
                <i v-if="sortColumn == 'team'" class="fa fa-sort-asc"></i>
            </th>
            <th>
                {{ $trans.get('__JSON__.Date') }}
            </th>
            <th role="button" @click.prevent="sortColumn = 'created_at'">
                {{ $trans.get('__JSON__.Date requested') }}
                <i v-if="sortColumn == 'created_at'" class="fa fa-sort-asc"></i>
            </th>
            <th>
                {{ $trans.get('__JSON__.Actions') }}
            </th>
            </tr>   
        </thead>
        <tbody>
            <tr v-for="vacationOpenRequest in sortedVacationOpenRequests" :key="'et-' + vacationOpenRequest.id">
                <td>
                    {{ makeFullname(vacationOpenRequest.employee.lastname, vacationOpenRequest.employee.forename) }}
                </td>
                <td>
                    {{ vacationOpenRequest.employee.team?.name }}
                </td>
                <td>
                    {{ makeTimeframe(toYMDFormat(vacationOpenRequest.start_at), toYMDFormat(vacationOpenRequest.end_at),
                vacationOpenRequest.half_day) }}
                </td>
                <td>
                    <i v-if="isYesterdayOrBefore(vacationOpenRequest.created_at)" class="fa fa-warning text-danger"
                        v-tooltip title="Urlaubsantrag älter als ein Tag!"></i>&nbsp;
                    {{ toYMDHMFormat(vacationOpenRequest.created_at) }}
                </td>
                <td>
                    <div>
                        <button class="btn btn-primary"
                            @click="goToOverview(toYMDFormat(vacationOpenRequest.start_at), vacationOpenRequest.employee.team?.id, vacationOpenRequest.employee.id)">
                            {{ $trans.get('__JSON__.overview') }}</button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
    <button v-if="!year_switch && displayWindow && sortedFutureVacationOpenRequests" @click="toggleDisplayWindow" class="btn btn-secondary">{{ $trans.get('__JSON__.display more') }} (+ {{ sortedFutureVacationOpenRequests.length }})</button>
    <button v-if="!year_switch && !displayWindow" @click="toggleDisplayWindow" class="btn btn-secondary">{{ $trans.get('__JSON__.display less') }}</button>
</template>


<script>
import getVacationOpenRequests from "../composables/vacationOpenRequests";

export default {

    name: "VacationOpenRequests",

    props: {
        monitor_others: Boolean,
        view_locations: Object,
        year: Number
    },
    setup(props) {
        const { vacationOpenRequests, vacationOpenRequest_error, loadVacationOpenRequests } = getVacationOpenRequests();
        loadVacationOpenRequests(props.monitor_others, props.view_locations, props.year);

        return { vacationOpenRequests, vacationOpenRequest_error, loadVacationOpenRequests };
    },
    data() {
        return {
            sortColumn: 'created_at',
            counted: null,
            year_switch: null,
            displayWindow:true
        };
    },
    created() {
        let refreshtime =  600000 + Math.floor(Math.random() * 120000);
        setInterval(this.refreshData,refreshtime)
    },
    watch: {
        year_switch: function () {
            if (!this.year_switch) {
                this.loadVacationOpenRequests(this.monitor_others, this.view_locations, this.year)
            }
            else {
                this.loadVacationOpenRequests(this.monitor_others, this.view_locations, this.getNextYear(this.year))
            }
        },
    },
    computed: {
        sortedVacationOpenRequests() {
            // Div im Blade verstecken, wenn es keine BEMs gibt.
            if (!this.vacationOpenRequests) {
                return null;
            }
            if (this.vacationOpenRequests.length == 0) {
                return null;
            }
            var displayWindow = new Date();
            displayWindow.setMonth(displayWindow.getMonth() + 3);

            return this.vacationOpenRequests.sort(this.compareVacationOpenRequests).filter( (vacationRequest) => (new Date(vacationRequest.start_at) <= displayWindow) || !this.displayWindow || this.year_switch);
        },
        sortedFutureVacationOpenRequests() {
            // Div im Blade verstecken, wenn es keine BEMs gibt.
            if (!this.vacationOpenRequests) {
                return null;
            }
            if (this.vacationOpenRequests.length == 0) {
                return null;
            }
            var displayWindow = new Date();
            displayWindow.setMonth(displayWindow.getMonth() + 3);

            return this.vacationOpenRequests.sort(this.compareVacationOpenRequests).filter( (vacationRequest) => new Date(vacationRequest.start_at) > displayWindow);
        }
    },
    methods: {
        toggleDisplayWindow() {
            this.displayWindow = !this.displayWindow;
        },
        toYMDFormat(dateString) { // yyyy-mm-dd
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth() + 1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd;

            return formattedDate;

        },
        toYMDHMFormat(dateString) { // yyyy-mm-dd hh:mi
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth() + 1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');
            var hh = date.getHours().toString().padStart(2, '0');
            var mi = date.getMinutes().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + mi;

            return formattedDate;

        },
        compareVacationOpenRequests(a, b) {
            if (this.sortColumn == 'created_at') {
                if (a.created_at == b.created_at) {
                    return 0;
                }
                if (a.created_at < b.created_at) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'team') {
                if (a.employee.team_id == b.employee.team_id) {
                    return 0;
                }
                if (a.employee.team_id < b.employee.team_id) {
                    return -1;
                }
            }

            if (this.sortColumn == 'employee') {
                if (a.employee.lastname > b.employee.lastname) {
                    return 1;
                }
                if (a.employee.lastname < b.employee.lastname) {
                    return -1;
                }
                if (a.employee.forename > b.employee.forename) {
                    return 1;
                }
                if (a.employee.forename < b.employee.forename) {
                    return -1;
                }
                if (a.created_at > b.created_at) {
                    return 1;
                }
                if (a.created_at < b.created_at) {
                    return -1;
                }
                return 0;
            }
            return 0;
        },
        getCountVacationOpenRequests() {
            if (!this.sortedVacationOpenRequests) {
                return counted = 0;
            }
            let counted = this.sortedVacationOpenRequests.length;
            return counted;
        },
        isYesterdayOrBefore(date) {
            var d = new Date();
            d.setDate(d.getDate() - 1);
            if (Date.parse(date) <= Date.parse(d)) {
                return true;
            }
            return false;
        },
        makeFullname(lastname, forename) {
            const fullname = lastname + ', ' + forename;
            return fullname;
        },
        makeTimeframe(startat, endat, halfday) {
            const dateDifferenceInDays = (dateInitial, dateFinal) =>
                (dateFinal - dateInitial) / 86_400_000;

            const dateDiff = dateDifferenceInDays(new Date(startat), new Date(endat));

            //console.log("Datumsdifferenz: " , dateDiff);
            if (dateDiff > 0) {
                const timeframe = startat + ' - ' + endat;
                return timeframe;
            }
            if (halfday == 1) {
                const halfdayTranslation = this.$trans.get("__JSON__.Half day")
                const halfdayMark = startat + ' ' + halfdayTranslation;
                return halfdayMark;
            }
            const singleday = startat;
            return singleday;
        },
        getNextYear(yearString) {
            if (yearString == null) {
                return null;
            }
            var date = new Date(Date.parse(yearString));
            var yyyy = date.getFullYear() + 1;

            var formattedYear = yyyy;

            return formattedYear;
        },
        goToOverview(start_at, team_id, employee_id) {
            let myNewPathname = "absences/overview?startdate=" + start_at + '&team_id=' + team_id + '&employee_id=' + employee_id;
            console.log(myNewPathname);
            console.log(decodeURIComponent(myNewPathname));
            window.location.href = decodeURIComponent(myNewPathname);
        },
        refreshData() {
            this.loadVacationOpenRequests(this.monitor_others, this.view_locations, this.year);
        },
    }
}

</script>